import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      zIndex: theme.zIndex.faceModal,
    },
    paper: {
      position: "relative",
      width: 450,
      padding: [20, 24],
      textAlign: "center",
      overflowY: "initial",
      borderRadius: 10,
      boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
      [theme.breakpoints.up("mobile")]: {
        width: 406,
        padding: [30, 40],
        borderRadius: 20,
      },
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      textAlign: "left",
      "& .MuiTextField-root": {
        marginLeft: 5,
        width: "75%",
      },
    },
    action: {
      padding: 0,
      marginTop: 10,
      marginBottom: 15,
      textDecoration: "underline",
      textTransform: "none",
      fontWeight: "normal",
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline",
      },
    },
    italicText: {
      marginTop: 15,
      fontStyle: "italic",
    },
    boldText: {
      marginTop: 30,
      marginBottom: 10,
      fontWeight: 700,
      "& span": {
        color: theme.palette.deletion.main,
      },
    },
    captionText: {
      marginTop: 20,
      "& a": {
        "&:hover": {
          "@media (hover: hover)": {
            textDecoration: "underline",
          },
        },
      },
    },
    radioButton: {
      "& label": {
        "& span": {
          padding: 2,
        },
      },
    },
    title: {
      color: theme.palette.cloudBirst,
      letterSpacing: ".5px",
      margin: "0 auto 10px",
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(17),
      lineHeight: theme.typography.pxToRem(25),
      padding: 0,
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(24),
        lineHeight: theme.typography.pxToRem(37),
        marginBottom: 20,
      },
    },
  }),
  { name: "CancelFeedbackModal" },
);
